"use strict";
var moment = require("moment");
var constants_1 = require("./constants");
function dateOfBirthValidator() {
    return function (control) {
        // date of birth must be a valid date
        var value = control.value;
        if (value && value !== '') {
            var dateValue = moment(value, constants_1.Constants.DATE_PARSE_FORMAT);
            if (!dateValue.isValid()) {
                return { 'invalid': value };
            }
            // date of birth must be on or before today
            if (dateValue.startOf('day').isAfter(moment().startOf('day'))) {
                return { 'afterToday': value };
            }
        }
        return null;
    };
}
exports.dateOfBirthValidator = dateOfBirthValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/date-of-birth.validator.js